import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { ROUTING_APP_1, ROUTING_TAB_1, ROUTING_TAB_2 } from '../../constants/routing';
import { NAME_APP1 } from '../../constants/wording'
import { Timer } from '../Timer/Timer';

export class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    document.body.addEventListener('click', this.hideCallFromOutside, true);
  }

  render() {
    const styles = {
      container: {
        fontFamily:'Poppins',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
      },
    };
    return (
      <div>
        <nav>
          <div style={styles.container} className="nav-wrapper">
            <div>
              <div className="app-logo" style={{ marginTop: 16 }}>
                <img src="/images/ima-genie.png" alt="Logo" style={{height: '40px'}}/>
              </div>
            </div>
            <div>
              <ul>
                <li>
                  <NavLink className="navLink" to={"/" + ROUTING_APP_1 + "/" + ROUTING_TAB_1} activeClassName="active">Fiche incident</NavLink>
                </li>
                <li>
                  <NavLink exact className="navLink" to={"/" + ROUTING_APP_1 + "/" + ROUTING_TAB_2} activeClassName="active">Services additionnels</NavLink>
                </li>
              </ul>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div className="chip" style={{ marginTop: 16 }}>
                  <img src="/images/avatar_women.png" alt="Contact Person"/>
                  Jane Doe
                </div>
                <Timer {...this.props} />
            </div>
          </div>
        </nav>
      </div>
    );
  }
}